import { render, staticRenderFns } from "./TaxPlatform.vue?vue&type=template&id=636c6f6b&scoped=true"
import script from "./TaxPlatform.vue?vue&type=script&lang=js"
export * from "./TaxPlatform.vue?vue&type=script&lang=js"
import style0 from "./TaxPlatform.vue?vue&type=style&index=0&id=636c6f6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636c6f6b",
  null
  
)

export default component.exports